var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCsharp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1969_407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 5.1585e-06H52.6667C54.1554 -0.00143394 55.6297 0.298246 57.0054 0.881893C58.3811 1.46554 59.631 2.3217 60.6837 3.40137C61.7363 4.48103 62.5711 5.76302 63.1402 7.17395C63.7092 8.58488 64.0014 10.0971 64 11.6239V52.3761C64.0014 53.9029 63.7092 55.4151 63.1402 56.826C62.5711 58.237 61.7363 59.519 60.6837 60.5986C59.631 61.6783 58.3811 62.5345 57.0054 63.1181C55.6297 63.7018 54.1554 64.0014 52.6667 64H11.3333C9.84463 64.0014 8.37026 63.7018 6.9946 63.1181C5.61894 62.5345 4.36901 61.6783 3.31633 60.5986C2.26366 59.519 1.4289 58.237 0.859846 56.826C0.29079 55.4151 -0.00139809 53.9029 5.02954e-06 52.3761V11.6239C-0.00139809 10.0971 0.29079 8.58488 0.859846 7.17395C1.4289 5.76302 2.26366 4.48103 3.31633 3.40137C4.36901 2.3217 5.61894 1.46554 6.9946 0.881893C8.37026 0.298246 9.84463 -0.00143394 11.3333 5.1585e-06V5.1585e-06Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4672 26.4075V29.1807H50.2404V26.4075H51.627V29.1807H54.4001V30.5672H51.627V33.3402H54.4001V34.7268H51.627V37.5H50.2404V34.7268H47.4672V37.5H46.0806V34.7268H43.3076V33.3402H46.0806V30.5672H43.3076V29.1807H46.0806V26.4075H47.4672ZM50.2404 30.567H47.4672V33.3402H50.2404V30.567Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3529 12.4802C39.5861 12.4802 45.9012 16.4084 49.2838 22.2475L49.2509 22.1913L40.7404 27.0914C39.0638 24.2525 35.9901 22.3366 32.4638 22.2971L32.3527 22.2964C26.9757 22.2964 22.6165 26.6556 22.6165 32.0326C22.6147 33.7274 23.0575 35.393 23.9006 36.8632C25.5788 39.793 28.7338 41.769 32.3529 41.769C35.9944 41.769 39.1673 39.7679 40.8369 36.8068L40.7963 36.8778L49.2939 41.8005C45.9484 47.5902 39.7197 51.5062 32.5707 51.5842L32.3529 51.5855C25.0968 51.5855 18.7638 47.633 15.3896 41.7631C13.7425 38.8975 12.8 35.5754 12.8 32.0326C12.8 21.2342 21.5539 12.48 32.3527 12.48L32.3529 12.4802Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1969_407"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCsharp);
export default __webpack_public_path__ + "static/media/csharp.c282b48a2aef1237db22d1bc4738811b.svg";
export { ForwardRef as ReactComponent };